import React from 'react'
import styles from './styles.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const iconMap = {
  general: 'icons',
}

function TabDescription({ children, title, icon = 'general' }) {
  return (
    <div className={styles.tabDescriptionContainer}>
      {iconMap[icon] && <FontAwesomeIcon data-testid="tab-description-icon" prefix="fal" icon={['fal', iconMap[icon]]} />}
      {title && <span className={styles.tabDescriptionTitle}>{title}</span>}
      {children}
    </div>
  )
}

export default TabDescription
